<script setup lang="ts">
import { ReviewSection, RenderName, RenderAddress, QuestionYesNo } from '@hfc/ui-core';
import { useSmallBusinessStore } from '@/application/smallBusiness/infrastructure/composition/useSmallBusinessStore';

const { smallBusinessState } = useSmallBusinessStore();

</script>
<template>
  <ReviewSection section-title="Company Info" :editable="false" :section-number="2">
    <template #content>
      <div class="flex w-full flex-col">
        <div class="flex w-full flex-col sm:flex-row justify-between gap-4 mt-2">
          <div class="flex flex-col">
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              Legal Company Name
            </label>
            <div class="flex items-center text-xl space-x-4 lining-nums">
              <RenderName v-if="smallBusinessState.application.company.name" icon="briefcase" :first-name="smallBusinessState.application.company.name" />
            </div>
          </div>
          <div class="flex flex-col">
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              Address
            </label>
            <div class="flex text-lg space-x-4 lining-nums">
              <RenderAddress :line-one="smallBusinessState.application.company.main_address?.line_one" :line-two="smallBusinessState.application.company.main_address?.line_two" :city="smallBusinessState.application.company.main_address?.city" :state="smallBusinessState.application.company.main_address?.state" :zip="smallBusinessState.application.company.main_address?.zip_code" :two-lines="true" />
            </div>
          </div>
        </div>
        <div class="flex w-full flex-row justify-between gap-4 mt-6">
          <div class="flex flex-col">
            <QuestionYesNo v-model="smallBusinessState.application.company.is_mailing_address_same_as_main" question-text="Is mailing address the same as your Address (CA Headquarters)" id="sameAsMain" name="sameAsMain" :disabled="true" :show-answer="true" title-class="text-blue-500 font-medium text-lg" answer-class="text-lg" />
          </div>
        </div>
        <div v-if="smallBusinessState.application.company.mailing_address" class="flex w-full flex-row justify-between gap-4 mt-6">
          <div class="flex flex-col">
            <label class="font-medium mb-1 whitespace-nowrap text-sky-700 block">
              Mailing Address
            </label>
            <div class="flex text-lg space-x-4 lining-nums">
              <RenderAddress
                :line-one="smallBusinessState.application.company.mailing_address?.line_one"
                :line-two="smallBusinessState.application.company.mailing_address?.line_two"
                :city="smallBusinessState.application.company.mailing_address?.city"
                :state="smallBusinessState.application.company.mailing_address?.state"
                :zip="smallBusinessState.application.company.mailing_address?.zip_code"
                :two-lines="true"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </ReviewSection>
</template>
